export var INNER_PAGE_DRAG_END = 'INNER_PAGE_DRAG_END';
export function innerpageDragEnd(blocks) {
    return function (dispatch) {
        dispatch({
            type: INNER_PAGE_DRAG_END,
            payload: blocks
        });
    };
}
//# sourceMappingURL=innerpageblocks.js.mapexport var INNER_PAGE_DRAG_END = 'INNER_PAGE_DRAG_END';
export function innerpageDragEnd(blocks) {
    return function (dispatch) {
        dispatch({
            type: INNER_PAGE_DRAG_END,
            payload: blocks
        });
    };
}
//# sourceMappingURL=innerpageblocks.js.map